import { Cell, Grid, Heading } from 'bold-ui'
import { TelefoneField, TextField } from 'components/form'
import { NacionalidadeEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { ContatosFormModel } from 'view/cidadao/types/model-cidadao'

interface ContatosSectionProps {
  meta: MetaPath<ContatosFormModel>
  nacionalidade: NacionalidadeEnum
}

export const ContatosSection = ({ meta, nacionalidade }: ContatosSectionProps) => {
  const isBrasileiroOuNaturalizado = nacionalidade !== NacionalidadeEnum.ESTRANGEIRA

  return (
    <Grid>
      <Cell size={12}>
        <Heading level={2}>Contatos</Heading>
      </Cell>
      <Cell size={2}>
        <TelefoneField name={meta.telefoneCelular} label='Telefone celular' required={isBrasileiroOuNaturalizado} />
      </Cell>
      <Cell size={2}>
        <TelefoneField name={meta.telefoneResidencial} label='Telefone residencial' />
      </Cell>
      <Cell size={2}>
        <TelefoneField name={meta.telefoneContato} label='Telefone de contato' />
      </Cell>
      <Cell size={6} />
      <Cell size={6}>
        <TextField name={meta.email} label='E-mail' lowercase minLength={6} maxLength={100} />
      </Cell>
      <Cell size={6} />
    </Grid>
  )
}
